export enum ApiErrorCodes {
  INVALID_CLIENT_MESSAGE = "INVALID_CLIENT_MESSAGE",
  INVALID_CREDENTIALS_MESSAGE = "INVALID_CREDENTIALS_MESSAGE",
  WEAK_PASSWORD = "WEAK_PASSWORD",

  EMAIL_ALREADY_EXIST = "EMAIL_ALREADY_EXIST",
  GENERIC_HTTP_ERROR = "GENERIC_HTTP_ERROR",
}
